/** Preferred short display code for a team: abbreviation first, d_name as fallback. */
export function getTeamShortName(
  team?: {
    abbreviation?: string | null
    d_name?: string | null
    name?: string | null
  } | null
): string {
  if (!team) return ''
  return team.abbreviation || team.d_name || team.name || ''
}

/** Same as getTeamShortName, for flattened team_* fields on MatchPlayer-style objects. */
export function getPlayerTeamShortName(
  player?: {
    team_abbreviation?: string | null
    team_d_name?: string | null
    team_name?: string | null
  } | null
): string {
  if (!player) return ''
  return getTeamShortName({
    abbreviation: player.team_abbreviation,
    d_name: player.team_d_name,
    name: player.team_name,
  })
}
